import { render } from "./TableItems.vue?vue&type=template&id=b53a9152&scoped=true"
import script from "./TableItems.vue?vue&type=script&lang=js"
export * from "./TableItems.vue?vue&type=script&lang=js"

import "./TableItems.vue?vue&type=style&index=0&id=b53a9152&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b53a9152"]])

export default __exports__